import { createSlice, PayloadAction } from '@reduxjs/toolkit';
interface initialStateType {
  expired: boolean;
  lastActiveTime: Date;
  isNavigating: boolean;
}
const initialState: initialStateType = {
  expired: false,
  lastActiveTime: new Date(),
  isNavigating: false,
};

const sessionSlice = createSlice({
  name: 'SessionManager',
  initialState,
  reducers: {
    setTokenExpired(state: initialStateType, action: PayloadAction<void>) {
      state.expired = true;
    },
    setLastActiveTime(state: initialStateType, action: PayloadAction<void>) {
      state.lastActiveTime = new Date();
    },
    setNavigation(state: initialStateType, action: PayloadAction<void>) {
      state.isNavigating = true;
    },
  },
});
export default sessionSlice.reducer;
export const { setTokenExpired, setLastActiveTime, setNavigation } = sessionSlice.actions;
